<style scoped>
#grid {
  display: grid;
  grid-template-areas:
    'tvedit tvedit tvedit'
    'symbols smarttrade orderbook'
    'assets trades trades';
  /*grid-template-rows: 60px 470px 10px 400px 1fr;*/
  grid-template-columns: 28% 1fr 28%;
  grid-gap: 15px;
  /*grid-auto-rows: auto;*/
}

@media all and (min-width: 1201px) {
  #SmartTradeEditTrade {
    display: none;
  }
  #TabBar {
    display: none;
  }
  #TabBarItem {
    display: none;
  }
}

@media all and (max-width: 1200px) {
  #grid {
    grid-template-areas:
      'tvedit'
      'edittrade'
      'tabbar'
      'tabbaritem';
    /*"symbols"*/
    /*"orderbook"*/
    /*"assets"*/
    /*"trades";*/
    grid-template-columns: 1fr;
  }
  #EditTrade {
    display: none;
  }
  #SmartTrade {
    display: none;
  }
  #Symbols {
    display: none;
  }
  #OrderBook {
    display: none;
  }
  #Assets {
    display: none;
  }
  #Trades {
    display: none;
  }
}

#TVEditTrade {
  grid-area: tvedit;
}
#SmartTradeEditTrade {
  grid-area: edittrade;
  min-height: 400px;
}
#Symbols {
  grid-area: symbols;
}
#SmartTrade {
  grid-area: smarttrade;
}
#OrderBook {
  grid-area: orderbook;
}
#Assets {
  grid-area: assets;
}
#Trades {
  grid-area: trades;
}
#TabBar {
  grid-area: tabbar;
}
#TabBarItem {
  grid-area: tabbaritem;
}

.edit-trade {
  height: 100%;
}
</style>

<template>
  <div id="grid">
    <div id="TVEditTrade">
      <div style="display: flex">
        <TV2 style="flex: 100%" />
        <EditTrade2
          id="EditTrade"
          v-if="!mobile && $store.state.trade.editTrade"
          style="flex: 39%; margin-left: 10px"
        />
      </div>
    </div>
    <div id="SmartTradeEditTrade" v-if="mobile">
      <EditTrade2 v-if="$store.state.trade.editTrade" class="edit-trade" />
      <SmartTrade v-else />
    </div>
    <Symbols id="Symbols" v-if="!mobile"  @selectSymbol="selectSymbol"/>
    <SmartTrade id="SmartTrade" v-if="!mobile" />
    <OrderBook id="OrderBook" v-if="!mobile" />
    <MiniAssets id="Assets" mini v-if="!mobile" />
    <Trades id="Trades" v-if="!mobile" />
    <TerminalTabBar id="TabBar" />
    <div id="TabBarItem" v-if="mobile">
      <Symbols v-if="$store.state.trade.tabBarSelectedItem === 'Symbols'"  @selectSymbol="selectSymbol"/>
      <OrderBook
        v-else-if="$store.state.trade.tabBarSelectedItem === 'Orderbook'"
      />
      <MiniAssets
        v-else-if="$store.state.trade.tabBarSelectedItem === 'Assets'"
        mini
      />
      <Trades v-else />
    </div>
    <BackTop :duration="500" :right="70" :bottom="40" :height="800"></BackTop>
  </div>
</template>

<script>
import SmartTrade from './SmartTrade'
import Symbols from './Symbols'
import OrderBook from './OrderBook'
import MiniAssets from './MiniAssets'
import Trades from './Trades'
import TV2 from './TV2'
import TerminalTabBar from './TerminalTabBar'
import EditTrade2 from './EditTrade2'
import terminal from '@/services/terminal'

export default {
  name: 'Terminal',
  components: {
    SmartTrade,
    Symbols,
    OrderBook,
    MiniAssets,
    Trades,
    TV2,
    EditTrade2,
    TerminalTabBar
  },
  data () {
    return {
      mobile: false
    }
  },
  created () {
    // console.log(window.innerWidth)
    if (window.innerWidth < 1200) {
      this.mobile = true
    }
    window.addEventListener('resize', this.myEventHandler)
  },
  methods: {
    selectSymbol (symbol) {
      terminal.selectTerminalSymbol(symbol)
    },
    myEventHandler (e) {
      // console.log(window.innerWidth)
      if (window.innerWidth < 1200) {
        this.mobile = true
      } else {
        this.mobile = false
      }
    }
  }
}
</script>
